import { render } from "./GeneralLedgerSummaryMonthly.vue?vue&type=template&id=16c4e5c6&scoped=true"
import script from "./GeneralLedgerSummaryMonthly.vue?vue&type=script&lang=js"
export * from "./GeneralLedgerSummaryMonthly.vue?vue&type=script&lang=js"

import "./GeneralLedgerSummaryMonthly.vue?vue&type=style&index=0&id=16c4e5c6&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c4e5c6"]])

export default __exports__